// ---------------------------
// AUTO-GENERATED. DO NOT EAT.
// ---------------------------
import { createEnum } from "@cartographerio/util";
const Bedrock = "BE";
const Boulder = "BO";
const Cobble = "CO";
const GravelPebble = "GP";
const Sand = "SA";
const Silt = "SI";
const Clay = "CL";
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const MrsBedMaterialParticleSizeEnum = {
    ...createEnum("MrsBedMaterialParticleSize", [
        [Bedrock, "Bedrock"],
        [Boulder, "Boulder"],
        [Cobble, "Cobble"],
        [GravelPebble, "Gravel-Pebble"],
        [Sand, "Sand"],
        [Silt, "Silt"],
        [Clay, "Clay"],
    ]),
    Bedrock,
    Boulder,
    Cobble,
    GravelPebble,
    Sand,
    Silt,
    Clay,
};
null;
null;
export default MrsBedMaterialParticleSizeEnum;
//# sourceMappingURL=MrsBedMaterialParticleSizeEnum.generated.js.map